import { FC, useEffect } from 'react';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { BookingObjectTypeSelect } from 'src/components/BookingObjectTypeSelect/BookingObjectTypeSelect';
import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';
import { labelsByBookingObjectType } from 'src/pages/AdministratorPage/consts';
import { bookingsActions } from 'src/store/bookings/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { MyBookingsFilterButton } from '../MyBookingsFilters/MyBookingsFiltersSidesheet/MyBookingsFilterButton';
import { MyBookingsPageModeSwitcher } from '../MyBookingsPageMode/MyBookingsPageModeSwitcher';
import { useMyBookingsType } from '../MyBookingsType/MyBookingsTypeProvider';

import classes from './MyBookingsActions.module.scss';

const bookingObjectTypeOptions: Option<string>[] = [
  BookingObjectType.Desk,
  BookingObjectType.MeetingRoom,
  BookingObjectType.PhoneRoom,
  BookingObjectType.FocusRoom,
  BookingObjectType.Parking,
].map(bot => ({ id: bot, value: labelsByBookingObjectType[bot] }));

export const MyBookingsActions: FC = () => {
  const dispatch = useAppDispatch();

  const { type, setType } = useMyBookingsType();

  useEffect(() => {
    dispatch(bookingsActions.setBookingObjectType(type));
  }, [dispatch, type]);

  return (
    <div className={classes.actions}>
      <div className={classes.type}>
        <BookingObjectTypeSelect
          options={bookingObjectTypeOptions}
          bookingObjectType={type}
          setBookingObjectType={setType}
        />
      </div>
      <div className={classes.controls}>
        <MyBookingsFilterButton />
        <MyBookingsPageModeSwitcher />
      </div>
    </div>
  );
};
